import {
  Component,
  OnInit,
  ViewChild,
  Input,
  OnDestroy,
  NgZone,
} from "@angular/core";
import { authenticationService } from "src/app/Services/Authentication/authentication.service";
import { ViewController } from "@ionic/core";
import {
  PopoverController,
  ModalController,
  AlertController,
  ActionSheetController,
  LoadingController,
  NavParams,
  IonContent,
} from "@ionic/angular";
import { SharedService } from "src/app/Services/sheared/sharedService.service";
import { AssureurService } from "src/app/Services/Assureur/assureur.service";
import { Observable, Subscription } from "rxjs";
import { CotationVoyageService } from "src/app/Services/Cotation/cotationVoyage.service";
import { FactoryService } from "src/app/Services/historique/factory.service";
import { PaiesimulateComponent } from "../../paiesimulate/paiesimulate.component";
import { CotationService } from "src/app/Services/Cotation/cotation.service";
import { SimulMoney } from "src/app/Services/Cotation/ModelCotations";
import { isUndefined } from "util";
import { Camera, PictureSourceType } from "@ionic-native/camera/ngx";
import { PaiementService } from "src/app/Services/Paiement/paiement.service";
import { Router } from "@angular/router";
import { IonicSelectableComponent } from "ionic-selectable";

@Component({
  selector: "app-voyresumeprime",
  templateUrl: "./voyresprime.component.html",
  styleUrls: ["./voyresprime.component.scss"],
})
export class VoyResPrimeComponent implements OnInit, OnDestroy {
  dtjr: string;
  objetpass: any;
  itemsData: any[] = [];
  private items: any[] = [];
  select_Assureur: any = null;
  assureurs = [];
  selectedImage: string;
  fileList: string[] = [];
  textImageselect: boolean;
  isEnabled: boolean = false;
  TypeObjet: string = "";
  afficheVoyage: boolean = false;
  subs = new Subscription();
  loading: HTMLIonLoadingElement;
  options = {
    centeredSlides: true,
    loop: false,
    spaceBetween: -50,
  };
  @ViewChild(IonContent, { static: false }) content: IonContent;
  constructor(
    private modalCtrl: ModalController,
    private assureurService: AssureurService,
    private _sheard: SharedService,
    private auth: authenticationService,
    private actionSheetCtrl: ActionSheetController,
    private camera: Camera,
    private alertController: AlertController,
    private loadingController: LoadingController,
    private _fact: FactoryService,
    private _primeService: PaiementService,
    private _cotationVoyageService: CotationVoyageService,
    private _route: Router,
    private ngZ: NgZone,
    private nvparms: NavParams
  ) {
    this.objetpass = this.nvparms.get("value");
    this.objetpass.CodeAssur = this._fact.getData(201);
    this.objetpass.open = true;
    this.dtjr = this._sheard.ConvertDMYorYMD(this._sheard.getDate());
    this.assureurService.getAssureurs();

    //this.assur.getAssureurs()
  }

  onDetail(item) {
    item.open = !item.open;
  }
  ngOnDestroy(): void {
    this.fileList[0] = "";
    this.fileList[1] = "";
    try {
      //    this.subsimul.unsubscribe();
      // this.subprime.unsubscribe()
    } catch (error) {}
  }

  private uploadingVoyage($key: string, police) {
    let Id_voy = this._fact.getData(150);
    let voyage: any = {
      nom: Id_voy.nom,
      prenom: Id_voy.prenom,
      dateNaiss: this._sheard.ConvertDMYorYMD(Id_voy.dateNaiss.split("T")[0]),
      dateDebut: this._sheard.ConvertDMYorYMD(Id_voy.dateDebut.split("T")[0]),
      dateFin: this._sheard.ConvertDMYorYMD(Id_voy.dateFin.split("T")[0]),
      age: Id_voy.age,
      Destination: Id_voy.Destination,
      zone: Id_voy.zone,
      Police: police,
      ImPassport: this.fileList[0],
      PathBillet: "",
      PathPassport: "",
      ImgBillet: this.fileList[1],
      icon: "../../../assets/img/voyage.png",
      dateInsert: this._sheard.getTimeStampFromToday(), //, this._sheard.getDate(),
    };
    this._fact.seTtracking(new Date().toISOString(),
    'L6',
    false,
    '1000',
    "",
    "Enregistrement Voy",
    police)
    this._cotationVoyageService
      .uploadFile(this.fileList[0], "Voyages")
      .then((res) => {
        if (res) {
          res.ref.getDownloadURL().then((url) => {
            voyage.ImPassport = url;
            voyage.PathPassport = res.metadata.fullPath;
            this._cotationVoyageService
              .uploadFile(this.fileList[1], "Voyages")
              .then((result) => {
                if (result) {
                  result.ref.getDownloadURL().then((url) => {
                    voyage.ImgBillet = url;
                    voyage.PathBillet = result.metadata.fullPath;
                    this._cotationVoyageService
                      .instNewVoyage(voyage, this.objetpass.CodeAssur, $key)
                      .then(() => {
                        this.loading.dismiss().then((res) => {
                          if (res) {
                            this.modalCtrl.dismiss().then((res) => {
                              if (res) {
                                this.fileList = [];
                                voyage = {};
                                this.ngZ.run(() =>
                                  this._route
                                    .navigate(["prime/30"], {
                                      replaceUrl: true,
                                    })
                                    .finally(() => {
                                      this.loading.dismiss();
                                    })
                                );
                              }
                            });
                          }
                        });
                      });
                  });
                }
              });
          });
        }
      });

    // this._cotationVoyageService.instNewVoyage(voyage, this.objetpass.CodeAssur, $key).then(
    //   () => {
    //     this.loading.dismiss().then(
    //       (res) => {
    //         if (res) {
    //           this.modalCtrl.dismiss().then(
    //             (res) => {
    //               if (res) {
    //                 this._route.navigate(['prime/30']).finally(() => { this.loading.dismiss() })
    //                 }
    //             }
    //           )
    //         }
    //       }
    //     )
    //   }
    // )
  }
  PayerPrimer() {
    this.controlDeProvenance(this.TypeObjet);
  }

  onValider(item) {
    //this.objetpass.cartegrise=this.selectedImage
    this.presentPayment(item);
  }
  private async presentPayment(nameSelected) {
    let dateEffet = this._sheard.getDateWithTimeDMY();
    let jrs;
    let dateExpi;
    // this._sheard.TimeStampToformatDMY(this._sheard.getTimeStampFromToday())
    if (nameSelected.periode == "3 mois") {
      dateExpi = this._sheard.ConvertDMYorYMD(
        this._sheard.getDate(this._sheard.AddDays(this._sheard.getDate(), 89))
      );
    } else if (nameSelected.periode == "6 mois") {
      dateExpi = this._sheard.ConvertDMYorYMD(
        this._sheard.getDate(
          this._sheard.AddDays(
            this._sheard.getDate(),
            Math.round(this._sheard.DayOfyear(new Date()) / 2) - 1
          )
        )
      );
    } else if (nameSelected.periode == "12 mois") {
      dateExpi = this._sheard.ConvertDMYorYMD(
        this._sheard.getDate(
          this._sheard.AddDays(
            this._sheard.getDate(),
            this._sheard.DayOfyear(new Date()) - 1
          )
        )
      );
    }

    dateEffet = this._sheard.ConvertDMYorYMD(nameSelected.dateEff);
    dateExpi = this._sheard.ConvertDMYorYMD(nameSelected.dateEx);
    jrs =
      1 + 1 * this._sheard.diffDays(nameSelected.dateEff, nameSelected.dateEx);
    nameSelected.periode = jrs + " jours";

    const alert = await this.alertController.create({
      header: "Paiement de la prime",
      mode: "ios",
      message:
        "Vous avez choisi une couverture d'une durée de <strong>" +
        nameSelected.periode +
        "</strong>. Ce contrat d'assurance prendra donc effet à :" +
        "<p>*Date éffet <strong>" +
        dateEffet +
        "</strong></p>" +
        "<p>*Date expiration <strong>" +
        dateExpi +
        "</strong></p>" +
        "<p><strong>NB:</strong> Si vous reportez le paiement de la prime à un autre jour," +
        "la date d'effet sera la date de paiement </p><br>",

      buttons: [
        {
          text: "Annuler",
          role: "cancel",
          cssClass: "primary",
          handler: () => {
            //this._objet = "Selectionner l'objet"
          },
        },
        {
          text: "OK",
          handler: () => {
            this.afficheVoyage = true;
            this.objetpass.dateEffet = dateEffet;
            this.objetpass.dateExpi = dateExpi;
            this.objetpass.duree = jrs;

            setTimeout(() => {
              this.content
                .scrollToBottom(800)
                .then
                //() => this.affiche=true
                ();
              // $("#mytext").focus();
            });
          },
        },
      ],
    });
    await alert.present();
  }
  private async controlDeProvenance(provenance: string, _objet: any = null) {
    this.loading = await this.loadingController.create({
      message: "Envoi en cours...",
      duration: 60 * 1000,
      mode: "ios",
      spinner: "bubbles",
    });
    this.loading.present();
    this._fact.setData(30, []);
    //#region  VOYAGE
    let Police1;
    //let Police=(provenance=="AUTOMOBILE")? provenance:`${provenance} ACCIDENTS`
    this.objetpass.CodeAssur = this._fact.getData(201);
    Police1 = `VOY-${this._sheard.generatorPolice()}`;
    this.items = [];
    this.items.push({
      NumPolice: Police1,
      police: Police1,
      NomPrenom: this.auth.profile.NomPrenom,
      Notification: "",
      CodeAssur: this.objetpass.CodeAssur,
      NumRef: "",
      dateEffet: this._sheard.ConvertDMYorYMD(this.objetpass.dateEff),
      dateExpi: this._sheard.ConvertDMYorYMD(this.objetpass.dateEx),
      montant_due: this.objetpass.Ttc,
      montant_paye: 0,
      date_paiement: "",
      dateInsert: this._sheard.getDate(),
      etatdoc: "",
      icon: "../../../assets/icon/airplane.svg",
      flag: false,
      CodeMvt: "AFN",
      //isChecked:true,
      notifydoc: false,
      notify: true,
      duree: this.objetpass.duree,
      mode_paie: "",
      numClient: "", //this.auth.profile.numClient,
      solde: false,
      type: "Voyage",
      idKey: this.auth.profile.uid,
    });

    this._primeService.insertPrime(this.items).then((res) => {
      this.items[0].$key = res.key;
      this.items[0].nbPaie = 0;
      this.items[0].montantVerse = 0;
      this.items[0].montant_restant = this.objetpass.Ttc;
      this._fact.setData(30, this.items[0]);
      // if (isUndefined(this.objetpass.CodeAssur)) {
      //   this._primeService.addQuit(res.key,this.objetpass.CodeAssur)
      //     }
      this.uploadingVoyage(res.key, Police1);
    });

    //#endregion
  }
  getPicture(sourceType: PictureSourceType, typeimg: string) {
    this.camera
      .getPicture({
        quality: 100,
        destinationType: this.camera.DestinationType.DATA_URL,
        sourceType: sourceType,
        mediaType: this.camera.MediaType.PICTURE,
        encodingType: this.camera.EncodingType.JPEG,
        allowEdit: true,
        // targetWidth:1000,
        // targetHeight:1000,
        saveToPhotoAlbum: false,
        correctOrientation: true,
      })
      .then((imageData) => {
        if (typeimg == "pass") {
          this.fileList[0] = `data:image/jpeg;base64,${imageData}`;
        } else if (typeimg == "bill") {
          this.fileList[1] = `data:image/jpeg;base64,${imageData}`;
        } else {
          this.selectedImage = `data:image/jpeg;base64,${imageData}`;
        }

        this.desactiveBtn();
      });
  }
  private desactiveBtn() {
    this.isEnabled = false;
    this.objetpass.CodeAssur = this._fact.getData(201);
    if (this.objetpass.CodeAssur) {
      if (
        this.fileList[0] != "../../../assets/img/placeholder.jpg" &&
        this.fileList[1] != "../../../assets/img/placeholder.jpg"
      )
        this.isEnabled = true;
    }
  }
  async selectSource(typeimg: string) {
    const actionSheet = await this.actionSheetCtrl.create({
      mode: "ios",
      buttons: [
        {
          text: "Galerie photo",

          handler: () => {
            this.getPicture(
              this.camera.PictureSourceType.PHOTOLIBRARY,
              typeimg
            );
          },
        },
        {
          text: "Capture image",
          handler: () => {
            this.getPicture(this.camera.PictureSourceType.CAMERA, typeimg);
          },
        },
        {
          text: "Annuler",
          role: "cancel",
        },
      ],
    });
    await actionSheet.present();
  }
  userChange(event: { component: IonicSelectableComponent; value: any }) {
    if (event.value) {
      this.objetpass.CodeAssur = event.value.CodeAssu;
      this.desactiveBtn();
    } else {
    }
  }

  ngOnInit() {
    this.TypeObjet = "VOYAGE";
    this.fileList[0] = this.fileList[1] = "../../../assets/img/placeholder.jpg";
    let timer=setTimeout(() => {
      this.itemsData.push(this.objetpass);
      clearTimeout(timer)
    }, 100);
    
    this.assureurService.ListAssreurs.subscribe((res) => {
      try {
        this.assureurs = res;
        // if (isUndefined(this.objetpass.CodeAssur)) {
        //   this.assureurs = res
        // }else
        // {
        //   this.assureurs = res.filter(a => (a.CodeAssu === this.objetpass.CodeAssur))
        // }
      } catch (error) {}
    });

    this._fact.seTtracking(new Date().toISOString(),
    'L5',
    false,
    '1000',
    "",
    "Prime Voy",
    "")
  }
}
